import React from 'react';

const CHUNK_RELOAD_WINDOW_MS = 30 * 1000;
const CHUNK_RELOAD_KEY_PREFIX = 'bw:chunk-reload:';

export const isChunkLoadError = (error) => {
  const name = String(error?.name || '');
  const message = String(error?.message || error || '');
  return (
    name === 'ChunkLoadError' ||
    /Loading (CSS )?chunk .+ failed/i.test(message) ||
    /Failed to fetch dynamically imported module/i.test(message)
  );
};

export const getChunkReloadKey = (location = window.location) =>
  `${CHUNK_RELOAD_KEY_PREFIX}${location.pathname || '/'}${location.search || ''}`;

class ChunkLoadRecoveryBoundary extends React.Component {
  state = { error: null };

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error) {
    if (!isChunkLoadError(error)) return;

    const recoveryKey = getChunkReloadKey();
    let lastReloadAt = 0;
    try {
      lastReloadAt = Number(window.sessionStorage.getItem(recoveryKey) || 0);
    } catch (_) {
      // Some privacy modes disable sessionStorage; a normal reload still recovers stale chunks.
    }
    if (!lastReloadAt || Date.now() - lastReloadAt > CHUNK_RELOAD_WINDOW_MS) {
      try {
        window.sessionStorage.setItem(recoveryKey, String(Date.now()));
      } catch (_) {
        // Keep recovery available even when browser storage is unavailable.
      }
      window.location.reload();
    }
  }

  reload = () => {
    try {
      window.sessionStorage.removeItem(getChunkReloadKey());
    } catch (_) {
      // Reload does not depend on sessionStorage being writable.
    }
    window.location.reload();
  };

  render() {
    const { error } = this.state;
    if (!error) return this.props.children;

    const chunkError = isChunkLoadError(error);
    return (
      <main
        role='alert'
        style={{
          minHeight: '100vh',
          display: 'grid',
          placeItems: 'center',
          padding: 24,
          background: '#f7f9fc',
        }}>
        <section
          style={{
            width: 'min(520px, 100%)',
            padding: 28,
            border: '1px solid #e6eaf0',
            borderRadius: 16,
            background: '#fff',
            boxShadow: '0 12px 32px rgba(15, 23, 42, 0.08)',
            textAlign: 'center',
          }}>
          <h1 style={{ margin: '0 0 8px', fontSize: 22 }}>
            {chunkError ? 'Đang cập nhật phiên bản mới' : 'Không thể hiển thị trang'}
          </h1>
          <p style={{ margin: '0 0 20px', color: '#64748b', lineHeight: 1.6 }}>
            {chunkError
              ? 'Trình duyệt đang dùng tệp giao diện cũ. Hãy tải lại để tiếp tục trên phiên bản mới nhất.'
              : 'Trang gặp lỗi ngoài dự kiến. Hãy tải lại; nếu lỗi còn lặp lại, vui lòng báo bộ phận kỹ thuật.'}
          </p>
          <button
            type='button'
            onClick={this.reload}
            style={{
              minHeight: 40,
              padding: '0 18px',
              border: 0,
              borderRadius: 8,
              background: '#dc2626',
              color: '#fff',
              fontWeight: 600,
              cursor: 'pointer',
            }}>
            Tải lại phiên bản mới
          </button>
        </section>
      </main>
    );
  }
}

export default ChunkLoadRecoveryBoundary;
